import QuotePDF from "components/pdfs/Quote/quote";
import { Signin } from "views/auth/signin";
import { ForgotPassword } from "views/auth/signin/forgotpassword";
import { ImpersonateSignin } from "views/auth/signin/impersonate";
import { MagicSignin } from "views/auth/signin/magic";
import { SigninOTP } from "views/auth/signin/otp";
import { ResetPassword } from "views/auth/signin/resetpassword";
import { Signup } from "views/auth/signup/account";
import { SignupUser } from "views/auth/signup/user";

const Routes = [
  {
    path: "/app/signup",
    view: Signup,
    layout: "auth",
    title: "Sign up to Cover Badger",
  },
  {
    path: "/app/quote_pdf",
    view: QuotePDF,
    layout: "auth",
    title: "Sign up to Cover Badger",
  },
  {
    path: "/app/signup/user",
    view: SignupUser,
    layout: "auth",
    title: "Sign up to Cover Badger",
  },
  {
    path: "/app/",
    view: Signin,
    layout: "auth",
    title: "Welcome to Cover Badger",
  },
  {
    path: "/",
    view: Signin,
    layout: "auth",
    title: "Welcome to Cover Badger",
  },
  {
    path: "/app/signin/otp",
    view: SigninOTP,
    layout: "auth",
    title: "Enter verification code",
  },
  {
    path: "/app/magic",
    view: MagicSignin,
    layout: "auth",
    title: "Sign In",
  },
  {
    path: "/app/forgotpassword",
    view: ForgotPassword,
    layout: "auth",
    title: "Forgot Your Password?",
  },
  {
    path: "/app/resetpassword",
    view: ResetPassword,
    layout: "auth",
    title: "Reset Your Password",
  },
  {
    path: "/app/signin/impersonate",
    view: ImpersonateSignin,
    layout: "auth",
    title: "Sign in via Mission Control",
  },
];

export default Routes;
